/* ============================================================
   CDS Auto-Kit — Auto-ajout du sizing kit selon forme+longueur
   ============================================================
   Logique : quand la cliente ajoute au panier un produit avec
   line item property "_needs_kit=true" (= toggle "Je n'ai pas
   mes mesures" coche), on cherche la variante du Sizing Kit
   qui matche son combo forme+longueur et on l'ajoute au panier
   (si pas deja la).

   Sources de truth :
     - window.__CDS_KIT_HANDLE (set par theme.liquid via settings)
     - line item properties "Forme" et "Longueur" de l'item ajoute
     - line item property "_needs_kit=true"

   API : aucune — script auto-demarrant qui hook fetch + XHR.
   Detection des add-to-cart via /cart/add.js intercept.
============================================================ */
(function() {
  'use strict';

  var KIT_HANDLE = window.__CDS_KIT_HANDLE || '';
  var KIT_PRODUCT = null; /* cache du produit Sizing Kit avec variantes */
  var KIT_PRODUCT_PROMISE = null;

  /* Debug logs : verbose en console pour aider le diagnostic.
     Mettre window.__CDS_KIT_DEBUG = false pour les desactiver. */
  function log() {
    if (window.__CDS_KIT_DEBUG === false) return;
    var args = ['[CDSAutoKit]'].concat(Array.prototype.slice.call(arguments));
    try { console.log.apply(console, args); } catch (e) {}
  }
  log('Init — kit handle:', KIT_HANDLE || '(non defini)');

  /* Normalisation accent + case + espaces multiples pour matcher les variantes
     de facon robuste (gere "Coffin Medium" vs "coffin  medium" vs "Café" etc) */
  function normalize(str) {
    if (!str) return '';
    return String(str)
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Recupere le produit Sizing Kit 1x (memo Promise). */
  function loadKitProduct() {
    if (KIT_PRODUCT) return Promise.resolve(KIT_PRODUCT);
    if (KIT_PRODUCT_PROMISE) return KIT_PRODUCT_PROMISE;
    if (!KIT_HANDLE) return Promise.resolve(null);
    KIT_PRODUCT_PROMISE = fetch('/products/' + KIT_HANDLE + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(product) {
        KIT_PRODUCT = product;
        return product;
      })
      .catch(function() { return null; });
    return KIT_PRODUCT_PROMISE;
  }

  /* Cherche la variante du kit dont le titre matche le combo forme+longueur.
     Strategie : match exact apres normalisation, sinon match partiel. */
  function findKitVariant(forme, longueur) {
    if (!KIT_PRODUCT || !KIT_PRODUCT.variants) return null;
    var label = normalize(forme + ' ' + longueur);
    /* Match exact */
    for (var i = 0; i < KIT_PRODUCT.variants.length; i++) {
      var v = KIT_PRODUCT.variants[i];
      var vTitle = normalize(v.title || v.public_title || v.name || '');
      if (vTitle === label) return v;
    }
    /* Fallback : match partiel (utile si combo "Carré arrondi" + "extra court"
       doit trouver "Carré arrondi extra court") */
    for (var j = 0; j < KIT_PRODUCT.variants.length; j++) {
      var v2 = KIT_PRODUCT.variants[j];
      var vTitle2 = normalize(v2.title || v2.public_title || v2.name || '');
      if (vTitle2 === label) continue;
      /* Test que TOUS les mots de "label" sont dans vTitle2 */
      var allWords = label.split(' ').every(function(w) { return vTitle2.indexOf(w) !== -1; });
      if (allWords) return v2;
    }
    return null;
  }

  /* Recupere l'etat actuel du panier. */
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
  }

  /* Collecte les section IDs du cart drawer (memes que cds-product-page.js).
     Necessaire pour que la response du /cart/add.js renvoie le HTML des sections
     et que le drawer puisse se rafraichir. */
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  /* Ajoute une variante au panier avec une property "_auto_added=true" pour
     que le snippet cds-cart-kit-notice puisse afficher le bouton "Retirer".
     Inclut sections= pour recevoir le HTML du drawer rafraichi en retour. */
  function addVariantToCart(variantId) {
    var payload = {
      id: parseInt(variantId),
      quantity: 1,
      properties: { _auto_added: 'true' }
    };
    var sids = cartSectionIds();
    if (sids.length) payload.sections = sids.join(',');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    }).then(function(r) { return r.ok ? r.json() : null; });
  }

  /* Re-dispatche un event cart:update format Horizon pour que le cart drawer
     se rafraichisse avec les sections HTML retournees par /cart/add.js.
     Replique exactement CartAddEvent / CartUpdateEvent de assets/events.js. */
  function dispatchCartUpdate(sections, productId, qty) {
    if (!sections || !Object.keys(sections).length) return;
    var evt = new Event('cart:update', { bubbles: true });
    evt.detail = {
      resource: {},
      sourceId: 'cds-auto-kit',
      data: {
        source: 'cds-auto-kit',
        productId: productId,
        itemCount: qty,
        sections: sections
      }
    };
    document.dispatchEvent(evt);
  }

  /* Verifie si la variante kit est deja dans le panier. */
  function kitVariantInCart(cart, variantId) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return true;
    }
    return false;
  }

  /* Verifie si N'IMPORTE QUELLE variante du produit kit est deja dans le panier.
     Utilise pour decider si on doit afficher la popup info (1ere fois qu'un
     kit apparait dans le panier = on explique le workflow a la cliente). */
  function anyKitInCart(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === KIT_HANDLE) return true;
    }
    return false;
  }

  /* ============================================================
     Sync kits ↔ parent products
     ============================================================
     Si la cliente supprime son produit parent (set d'ongles avec _needs_kit=true),
     le kit auto-ajoute correspondant doit aussi etre retire — sinon elle peut
     checkout avec uniquement un kit gratuit, ce qui n'a aucun sens.

     Strategie : a chaque cart change, on trouve les kits sans parent matching
     leur forme+longueur et on les retire automatiquement.
  ============================================================ */

  /* Trouve les kits orphelins (auto-ajoutes mais sans parent matching). */
  function findOrphanKits(cart) {
    if (!cart || !cart.items) return [];
    var kits = [], parentLabels = [];
    cart.items.forEach(function(item) {
      var props = item.properties || {};
      if (getProp(props, ['_auto_added']) === 'true') {
        kits.push(item);
      } else if (getProp(props, ['_needs_kit']) === 'true') {
        var forme = getProp(props, ['Forme', 'forme', 'Forme des ongles']);
        var longueur = getProp(props, ['Longueur', 'longueur']);
        var label = normalize(forme + ' ' + longueur);
        if (label) parentLabels.push(label);
      }
    });
    if (!kits.length) return [];
    /* Pour chaque kit, on cherche un parent qui matche sa variante (forme+longueur).
       Match exact apres normalisation OU partiel (tous les mots du parent
       dans le titre du kit) — meme logique que findKitVariant. */
    return kits.filter(function(kit) {
      var kitTitle = normalize(kit.variant_title || kit.variant_options && kit.variant_options.join(' ') || '');
      if (!kitTitle) return true; /* sans titre on considere orphelin */
      for (var i = 0; i < parentLabels.length; i++) {
        var pl = parentLabels[i];
        if (pl === kitTitle) return false;
        var allWords = pl.split(' ').every(function(w) {
          return w && kitTitle.indexOf(w) !== -1;
        });
        if (allWords) return false;
      }
      return true; /* aucun parent ne matche → orphelin */
    });
  }

  /* Compteur des suppressions internes en cours, pour eviter que notre hook
     fetch se re-declenche sur nos propres /cart/change.js (boucle inutile). */
  var internalRemovalInFlight = 0;
  var syncDebounceTimer = null;

  /* Retire une ligne du panier via /cart/change.js. Format JSON (comme cds-product-page.js)
     + sections= pour recevoir le HTML du drawer rafraichi. */
  function removeCartItem(key) {
    internalRemovalInFlight++;
    var sids = cartSectionIds();
    var payload = { id: key, quantity: 0 };
    if (sids.length) payload.sections = sids.join(',');
    var p = fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    }).then(function(r) {
      return r.ok ? r.json() : null;
    }).then(function(result) {
      if (result && result.sections) {
        var qty = (result.item_count != null) ? result.item_count : 0;
        dispatchCartUpdate(result.sections, null, qty);
      }
      return result;
    }).catch(function(err) {
      log('Erreur suppression item:', err);
      return null;
    });
    /* finally polyfill pour les vieux navigateurs */
    p.then(function() { internalRemovalInFlight--; }, function() { internalRemovalInFlight--; });
    return p;
  }

  /* Verifie l'etat du panier et retire les kits orphelins, en sequentiel
     (evite les races sur /cart/change.js qui n'aime pas les requetes paralleles). */
  function syncKitsToParents() {
    return getCart().then(function(cart) {
      var orphans = findOrphanKits(cart);
      if (!orphans.length) return;
      log('Kits orphelins detectes (parent supprime du panier):', orphans.length, '— suppression auto');
      var chain = Promise.resolve();
      orphans.forEach(function(kit) {
        chain = chain.then(function() {
          log('Suppression kit orphelin:', kit.variant_title || kit.product_title || kit.key);
          return removeCartItem(kit.key);
        });
      });
      return chain;
    }).catch(function(err) {
      log('Erreur syncKitsToParents:', err);
    });
  }

  /* Debounce : si plusieurs cart changes arrivent en rafale (ex: l'utilisateur
     supprime 2 items rapidement), on regroupe en un seul sync. */
  function scheduleSyncKits() {
    if (syncDebounceTimer) clearTimeout(syncDebounceTimer);
    syncDebounceTimer = setTimeout(function() {
      syncDebounceTimer = null;
      syncKitsToParents();
    }, 150);
  }

  /* Recupere une line item property (case-insensitive sur les cles courantes). */
  function getProp(props, keys) {
    if (!props) return '';
    if (!Array.isArray(keys)) keys = [keys];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (props[k] != null && props[k] !== '') return String(props[k]);
    }
    /* Cherche en case-insensitive */
    var lowerKeys = keys.map(function(k) { return k.toLowerCase(); });
    for (var prop in props) {
      if (lowerKeys.indexOf(prop.toLowerCase()) !== -1 && props[prop] != null && props[prop] !== '') {
        return String(props[prop]);
      }
    }
    return '';
  }

  /* Logique principale : appelee APRES qu'un add-to-cart ait reussi. */
  function maybeAddKit(addedItem) {
    if (!addedItem) { log('Skip : addedItem null'); return; }
    if (!KIT_HANDLE) { log('Skip : __CDS_KIT_HANDLE non defini (config settings manquante)'); return; }

    log('maybeAddKit appele pour item:', addedItem.handle || addedItem.product_id, 'properties:', addedItem.properties);

    /* Skip si c'est le kit lui-meme qu'on vient d'ajouter (evite boucle) */
    if (addedItem.handle === KIT_HANDLE) { log('Skip : c est le kit lui-meme'); return; }

    var props = addedItem.properties || {};

    /* Skip si le produit ajoute est lui-meme "auto_added" (evite boucle infinie) */
    if (getProp(props, ['_auto_added']) === 'true') { log('Skip : _auto_added=true'); return; }

    /* Skip si le produit n'a pas le toggle "Je n'ai pas mes mesures" coche.
       Convention : line item property "_needs_kit=true" stockee depuis les
       sections cds-product-page et cds-outfit-finder quand le toggle est sur "non". */
    var needsKit = getProp(props, ['_needs_kit']);
    if (needsKit !== 'true') {
      log('Skip : _needs_kit n est pas "true" (valeur:', JSON.stringify(needsKit) + '). Le toggle "J ai mes mesures" est-il coche, ou le hidden input n est-il pas dans le FormData ?');
      return;
    }

    /* Extract forme + longueur depuis les line item properties.
       Les noms exacts varient selon la section : "Forme" / "forme" / etc. */
    var forme = getProp(props, ['Forme', 'forme', 'Forme des ongles']);
    var longueur = getProp(props, ['Longueur', 'longueur']);
    if (!forme || !longueur) {
      log('Forme ou Longueur manquante dans les properties:', props);
      return;
    }
    log('Forme + Longueur trouves:', forme, '/', longueur);

    /* Charge le kit + cherche la variante matching */
    return loadKitProduct().then(function(product) {
      if (!product) {
        log('Produit Sizing Kit introuvable (handle:', KIT_HANDLE + '). Verifier que le settings est bien configure.');
        return;
      }
      log('Produit kit charge avec', (product.variants || []).length, 'variantes');
      var variant = findKitVariant(forme, longueur);
      if (!variant) {
        log('Variante kit introuvable pour:', forme + ' ' + longueur + '. Variantes disponibles:', (product.variants || []).map(function(v) { return v.title; }));
        return;
      }
      /* Garde-fou rupture de stock : si la variante kit est indisponible, l'ajout
         echouerait en silence (meme angle mort que la colle). On skip proprement
         plutot que de tenter une requete ratee. Le kit est offert donc en principe
         en stock illimite, mais si le stock est suivi et tombe a 0, ce log permet
         a Chloe de diagnostiquer (produit ajoute cote client mais pas le kit). */
      if (variant.available === false) {
        log('Variante kit "' + variant.title + '" en RUPTURE de stock → auto-ajout ignore. Verifier le stock du produit Sizing Kit.');
        return;
      }
      log('Variante kit trouvee:', variant.title, '(id:', variant.id + ')');
      return getCart().then(function(cart) {
        if (kitVariantInCart(cart, variant.id)) {
          log('Variante kit deja dans le panier — skip');
          return;
        }
        /* Capture l'etat AVANT l'ajout pour decider si on doit afficher la popup.
           Si aucun kit n'est dans le panier, ce sera le PREMIER → on affiche.
           Si un autre kit (autre variante) est deja la, on reste silencieux. */
        var hadKitBefore = anyKitInCart(cart);
        log('Ajout de la variante kit au panier... (had kit before:', hadKitBefore + ')');
        return addVariantToCart(variant.id).then(function(result) {
          if (!result) { log('Ajout kit echoue (response null)'); return; }
          log('Kit ajoute au panier avec succes !');
          /* Refresh du cart drawer avec les sections HTML retournees.
             Crucial : sinon le drawer affiche l'etat AVANT le kit (race condition
             entre notre hook async et l'ouverture sync du drawer par le theme). */
          var qty = (result.items_count != null) ? result.items_count : 1;
          dispatchCartUpdate(result.sections, result.product_id, qty);
          /* Met aussi a jour le compteur du bouton panier */
          try {
            getCart().then(function(cart) {
              document.querySelectorAll('[ref="cartBubble"],[data-cart-count],.cart-count').forEach(function(el) {
                if (el && cart && cart.item_count != null) el.textContent = cart.item_count;
              });
            });
          } catch (e) {}
          /* Ouvre la popup info uniquement si c'est le PREMIER kit du panier.
             forceOpen ignore le gate sessionStorage : la cliente la voit a
             chaque fois qu'un kit devient le premier kit du panier (1ere visite,
             ou apres avoir vide son panier puis re-ajoute un produit).
             setTimeout : on attend que le cart drawer soit ouvert pour que la
             popup arrive AU-DESSUS via dialog.showModal() (top-layer). */
          if (!hadKitBefore) {
            log('Premier kit du panier → affichage popup info dans 450ms');
            setTimeout(function() {
              if (window.CDSKitPopup && typeof window.CDSKitPopup.forceOpen === 'function') {
                window.CDSKitPopup.forceOpen();
              } else {
                log('CDSKitPopup.forceOpen indisponible — popup pas affichee');
              }
            }, 450);
          } else {
            log('Un autre kit etait deja dans le panier — pas de popup');
          }
          /* Re-trigger un event additionnel pour les listeners custom (optionnel) */
          document.dispatchEvent(new CustomEvent('cds:cart:updated', { detail: { autoKit: true } }));
        });
      });
    });
  }

  /* ============================================================
     Hook intercept des add-to-cart
     Shopify themes utilisent fetch() ou XHR pour POST /cart/add.js
     On intercepte les 2 et declenche maybeAddKit apres succes.
  ============================================================ */

  /* Hook fetch */
  var origFetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var method = (init && init.method) || (input && input.method) || 'GET';
    var methodUpper = String(method).toUpperCase();
    var isCartAdd = url && url.indexOf('/cart/add') !== -1 && methodUpper !== 'GET';
    /* /cart/change.js (suppression/qty) ou /cart/update.js (mass update) → on
       declenche un sync APRES pour retirer les kits orphelins. On exclut
       /cart/clear.js (le panier est vide, rien a synchroniser). */
    var isCartChange = url && methodUpper !== 'GET' && (
      url.indexOf('/cart/change') !== -1 ||
      (url.indexOf('/cart/update') !== -1 && url.indexOf('/cart/add') === -1)
    );
    var p = origFetch.apply(this, arguments);
    if (isCartAdd) {
      log('Intercept fetch /cart/add');
      p.then(function(response) {
        if (response.ok) {
          response.clone().json().then(function(data) {
            /* data peut etre un item seul ou { items: [...] } selon la version Shopify */
            var items = data.items || (data.id ? [data] : []);
            log('Response add-to-cart : ' + items.length + ' item(s)');
            items.forEach(function(item) { maybeAddKit(item); });
          }).catch(function() { log('Response pas en JSON — ignore'); });
        } else {
          log('Response add-to-cart NOT OK :', response.status);
        }
      }).catch(function() { /* erreur reseau — ignore */ });
    }
    /* Si la requete vient de NOTRE removeCartItem (internalRemovalInFlight > 0),
       on skip pour eviter une boucle inutile (apres notre suppression, il n'y a
       plus d'orphelin a nettoyer). */
    if (isCartChange && internalRemovalInFlight === 0) {
      p.then(function(response) {
        if (response.ok) {
          log('Cart change detecte — verification kits orphelins dans 150ms');
          scheduleSyncKits();
        }
      }).catch(function() {});
    }
    return p;
  };
  log('Hook fetch installe');

  /* Hook XHR (certaines libs anciennes l'utilisent encore) */
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._cdsUrl = url;
    this._cdsMethod = method;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    var methodUpper = (xhr._cdsMethod || '').toUpperCase();
    var isCartAdd = xhr._cdsUrl && xhr._cdsUrl.indexOf('/cart/add') !== -1 && methodUpper !== 'GET';
    var isCartChange = xhr._cdsUrl && methodUpper !== 'GET' && (
      xhr._cdsUrl.indexOf('/cart/change') !== -1 ||
      (xhr._cdsUrl.indexOf('/cart/update') !== -1 && xhr._cdsUrl.indexOf('/cart/add') === -1)
    );
    if (isCartAdd) {
      xhr.addEventListener('load', function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var data = JSON.parse(xhr.responseText);
            var items = data.items || (data.id ? [data] : []);
            items.forEach(function(item) { maybeAddKit(item); });
          } catch (e) { /* ignore */ }
        }
      });
    }
    if (isCartChange && internalRemovalInFlight === 0) {
      xhr.addEventListener('load', function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          scheduleSyncKits();
        }
      });
    }
    return origSend.apply(this, arguments);
  };
})();
